function importAll(r) {
    let images = {};
    r.keys().forEach((item) => { images[item.replace('./', '')] = r(item); });
    return images
}
let cert = []
cert = importAll(require.context('../../assets/certificates', false, /\.(png|jpe?g|svg)$/))
const arr = []
for (const key in cert) {
    arr.push({
        key: key && key.split('.')[0],
        value: cert[key],
        by: key && key.split('_')[1]
    })
}
export default arr